/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeTransferWorkflowRequestBody
 */
export interface ChangeTransferWorkflowRequestBody {
    /**
     * Identifier of new workflow to assign
     * @type {string}
     * @memberof ChangeTransferWorkflowRequestBody
     */
    workflowId: string;
}

/**
 * Check if a given object implements the ChangeTransferWorkflowRequestBody interface.
 */
export function instanceOfChangeTransferWorkflowRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "workflowId" in value;

    return isInstance;
}

export function ChangeTransferWorkflowRequestBodyFromJSON(json: any): ChangeTransferWorkflowRequestBody {
    return ChangeTransferWorkflowRequestBodyFromJSONTyped(json, false);
}

export function ChangeTransferWorkflowRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeTransferWorkflowRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workflowId': json['workflow_id'],
    };
}

export function ChangeTransferWorkflowRequestBodyToJSON(value?: ChangeTransferWorkflowRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workflow_id': value.workflowId,
    };
}

